//
// Generated class BankEntry
//

/// <reference path="BankEntry_ManagedObject.ts" />

class BankEntry extends BankEntry_ManagedObject
{
    get monthString():string {
        let yy = MIODateGetYearFromDate ( this.date );
        let mm = MIODateGetMonthFromDate( this.date )
        return String(yy) + "-" + String(mm);
    }
}
